/**
 * DashboardStats - Progress and Explorer Rank section
 */
import { Progress } from "@/components/ui/progress";
import ExplorerRank from "@/components/ExplorerRank";

const DashboardStats = ({ stats, onOpenMap }) => {
  const progress = stats ? (stats.total_items > 0 ? Math.round((stats.completed_items / stats.total_items) * 100) : 0) : 0;

  return (
    <div className="mb-8 animate-fade-in grid grid-cols-1 lg:grid-cols-2 gap-6">
      {/* Bucket List Progress */}
      {stats && (
        <div className="bg-card rounded-2xl border border-border shadow-card p-6">
          <div className="flex flex-col justify-between h-full gap-4">
            <div>
              <h2 className="font-serif text-2xl font-medium text-foreground mb-2">
                Your Progress
              </h2>
              <p className="text-muted-foreground">
                {stats.completed_items} of {stats.total_items} dreams achieved
              </p>
            </div>
            
            <div>
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm font-medium text-foreground">{progress}% Complete</span>
              </div>
              <Progress value={progress} className="h-3" />
            </div>
          </div>
        </div>
      )}
      
      {/* Explorer Rank */}
      <ExplorerRank onOpenMap={onOpenMap} />
    </div>
  );
};

export default DashboardStats;
